<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Stock Movement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Stock Movement Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Stock Movement",
          active: true,
        },
      ],
      totalRows: 1,
      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsStockMovementPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false, 
      id: atob(this.$route.params.id),
      data: {
        dto: moment(new Date()).format("YYYY-MM-DD"),
        dfrom: "",
        type: 10,
      },
      // Server-side filter object for movements
      filterMovements: {
      id: atob(this.$route.params.id),
      page: 1,
      per_page: 50,
      type: 10,
      date_from: "",
      date_to: moment(new Date()).format("YYYY-MM-DD"),
      search: "",
    },

      filterTitle: "",
      filteredReport: [],
      types: [
        { name: "All Types", id: 10 },
        { name: "Adding Product", id: 0 },
        { name: "Sale", id: 1 },
        { name: "Sale Return", id: 2 },
        { name: "Purchase", id: 3 },
        { name: "Purchase Return", id: 4 },
        { name: "Spoilt Stock", id: 5 },
        { name: "Expired", id: 6 },
        { name: "Reconciled", id: 7 },
        { name: "Stock Transfer", id: 8 },
      ],
    };
  },
  computed: {
    ...mapState("stock", ["stock_movements"]),
    ...mapGetters("stock", [
      "StockMovement",
      "StockMovementPagination",
      "SaveStatus",
      "StockMovementSummary",
    ]),

    rows() {
      return this.IsStockMovementPaginated
        ? this.StockMovementPagination.total
        : this.StockMovement
        ? this.StockMovement.length
        : 0;
    },

    stockMovementColumns() {
      const cols = [
        {
          key: "index",
          label: "S/N",
        },
        {
          key: "product",
          label: "PRODUCT",
        },
        {
          key: "from_quantity",
          label: "OLD QUANTITY",
        },
        {
          key: "qty_in",
          label: "QTY IN",
        },
        {
          key: "qty_out",
          label: "QTY OUT",
        },
        {
          key: "type_field",
          label: "TYPE",
        },
        {
          key: "user",
          label: "MADE BY",
        },
        {
          key: "date",
          label: "DATE",
        },
        {
          key: "date_recorded",
          label: "RECORDED ON",
        },
      ];

      return cols;
    },

    currentPage: {
      get() {
        return this.IsStockMovementPaginated
          ? this.StockMovementPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsStockMovementPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsStockMovementPaginated
          ? this.StockMovementPagination.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsStockMovementPaginated) {
          this.handlePerPageChange(value);
        } else {
          this.clientPerPage = value;
        }
      },
    },

    totals() {
      return (
        this.StockMovementSummary || {
          total_in: 0,
          total_out: 0,
          total_balance: 0,
        }
      );
    },
  },

  watch: {
    stock_movements(newValue) {
      if (newValue.data.length > 0) {
        this.assiginData();
      }
    },
    "data.type"() {
      this.filterMovements.type = this.data.type;
      this.FilterMovements();
    },
    "data.dfrom"() {
    this.filterMovements.date_from = this.data.dfrom;
    this.FilterMovements();
  },
    "data.dto"() {
      this.filterMovements.date_to = this.data.dto;
      this.FilterMovements();
    },

    filter() {
      // update query but don't fire immediately; search on Enter
      this.filterMovements.search = this.filter;
    },
  },

  methods: {
    ...mapActions({
      FetchMovements: "stock/fetchStockMovementsPaginated",
    }),

    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
   
    assiginData() {
      this.filteredReport = this.StockMovement;
    },

    handlePageChange(newPage) {
      if (this.IsStockMovementPaginated) {
        this.filterMovements.page = newPage;
        this.FetchMovements(this.filterMovements);
      } else {
        this.clientCurrentPage = newPage;
      }
    },

    handlePerPageChange(newPerPage) {
      if (this.IsStockMovementPaginated) {
        this.filterMovements.page = 1;
        this.filterMovements.per_page = newPerPage;
        this.FetchMovements(this.filterMovements);
      } else {
        this.clientPerPage = newPerPage;
      }
    },

    FilterMovements() {
      // ensure id included
      this.filterMovements.id = this.id;
      this.filterMovements.page = 1;
      this.FetchMovements(this.filterMovements);
    },

    filterReport() {
      let date2 = this.data.dto;
      let date1 = this.data.dfrom;
      this.filteredReport = this.StockMovement.filter((element) => {
        if (
          this.data.type != "10" &&
          this.data.dfrom == "" &&
          this.data.dto != ""
        ) {
          return element.type == this.data.type && element.date <= date2;
        } else if (
          this.data.type == "10" &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {
          return element.date >= date1 && element.date <= date2;
        } else if (
          this.data.type == 10 &&
          this.data.dfrom == "" &&
          this.data.dto != ""
        ) {
          return element.date <= date2;
        } else if (
          this.data.type != "10" &&
          this.data.dfrom != "" &&
          this.data.dto != ""
        ) {
          return (
            element.type == this.data.type &&
            element.date >= date1 &&
            element.date <= date2
          );
        }
      });
    },
  },
  
  created() {
    // initialize filters and fetch
    this.filterMovements.id = this.id;
    this.filterMovements.date_to = this.data.dto;
    this.filterMovements.date_from = this.data.dfrom;
    this.filterMovements.type = this.data.type;
    this.FetchMovements(this.filterMovements);
    this.assiginData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div align="right">
              <button
                @click="$router.go(-1)"
                class="btn btn-primary btn-sm mb-2"
              >
                <i class="fas fa-arrow-circle-left"></i> Go Back
              </button>
            </div>

            <div class="row">
              <div v-if="filterTitle">
                <h4>
                  <center>{{ filterTitle }}</center>
                </h4>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Movement Type</label>
                  <model-list-select
                    :list="types ? types : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Type"
                    @input="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dfrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    @change="filterReport()"
                    type="date"
                    v-model="data.dto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="filterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                      @keyup.enter="FilterMovements()"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="stockMovementColumns"
                :rows="StockMovement || []"
                :total-rows="rows"
                :pagination="StockMovementPagination"
                :server-pagination="IsStockMovementPaginated"
                :loading="SaveStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>

                <template #cell(product)="{ row }">
                  {{ row.product || "-" }}
                </template>

                <template #cell(from_quantity)="{ row }">
                  {{ row.from_quantity }}
                </template>

                <template #cell(qty_in)="{ row }">
                  {{ row.qty_in }}
                </template>

                <template #cell(qty_out)="{ row }">
                  {{ row.qty_out }}
                </template>

                <!-- TYPE FIELD -->
                <template #cell(type_field)="{ row }">
                  <span v-if="row.type == 1">Sale</span>
                  <span v-else-if="row.type == 0">Product</span>
                  <span v-else-if="row.type == 2">Sale Return</span>
                  <span v-else-if="row.type == 3">Purchase</span>
                  <span v-else-if="row.type == 4">Purchase Return</span>
                  <span v-else-if="row.type == 7">Reconciliation</span>
                  <span v-else-if="row.type == 8">Stock Transfer</span>
                  <span v-else-if="row.type == 5">Spoilt Stock</span>
                  <span v-else-if="row.type == 6">Expired</span>
                  <span v-else-if="row.type == 9">Output</span>
                </template>

                <template #cell(user)="{ row }">
                  {{ row.user || "-" }}
                </template>

                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>

                <template #cell(date_recorded)="{ row }">
                  {{ row.date_recorded }}
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-4">
                  <h5>
                    Total Qty In:
                    <span class="text-danger">{{
                      totals.total_in.toLocaleString()
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-4">
                  <h5>
                    Total Qty Out:
                    <span class="text-danger">{{
                      totals.total_out.toLocaleString()
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-4">
                  <h5>
                    Total Balance:
                    <span class="text-danger">{{
                      totals.total_balance.toLocaleString()
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
